import { render, staticRenderFns } from "./CustomerCreate.vue?vue&type=template&id=68873d9a&scoped=true"
import script from "./CustomerCreate.vue?vue&type=script&lang=js"
export * from "./CustomerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68873d9a",
  null
  
)

export default component.exports